<template>
    <div>
        <sidebar-menu :menu="menudata" @update:collapsed="onToggleCollapse" @item-click="onItemClick"
            :showOneChild="true" @toggle-collapse="onToggleCollapse">
            <template v-slot:header>
                <Link class="logo_link" href="/backend">
                <logo class="fill-white" width="28" height="28" />
                </Link>
            </template>
            <template v-slot:toggle-icon><i class="fas fa-arrows-alt-h"></i></template>
        </sidebar-menu>
    </div>
</template>

<script>
import axios from 'axios';
import Icon from '@/Shared/Icon';
import Logo from '@/Shared/Logo';
import { Link } from '@inertiajs/inertia-vue3';
import { SidebarMenu } from 'vue-sidebar-menu';
import TrashedMessage from '@/Shared/TrashedMessage';

export default {
    components: {
        Icon,
        Link,
        SidebarMenu,
        Logo,
        TrashedMessage
    },
    data() {
        return {
            window: {
                width: window.innerWidth,
                height: window.innerHeight
            },
            menudata: [],
        };
    },
    created() {
        window.addEventListener('resize', this.handleResize);
        this.handleResize();
        this.loadmenu();
    },
    beforeUnmount() {
        window.removeEventListener('resize', this.handleResize);
    },
    methods: {
        isUrl(...urls) {
            const currentUrl = this.$page.url.substr(1);
            if (!urls.length || urls[0] === '') {
                return currentUrl === '';
            }
            return urls.some(url => currentUrl.startsWith(url));
        },
        onToggleCollapse() {
            const contentArea = document.querySelector('.content-page');
            const topbarArea = document.querySelector('.topbar');
            const sidebarmenu = document.querySelector('.v-sidebar-menu');
            if (contentArea) contentArea.classList.toggle('enlarged');
            if (topbarArea) topbarArea.classList.toggle('enlarged');
            if (sidebarmenu) sidebarmenu.classList.toggle('enlarged');
        },
        handleResize() {
            this.window.width = window.innerWidth;
            this.window.height = window.innerHeight;
        },
        loadmenu() {
            axios.post('/backend/menu-managements/treemenu', {})
                .then((response) => {
                    this.menudata = response.data;
                })
                .catch((error) => {
                    // Optionally handle error
                    console.error('Menu load failed:', error);
                });
        }
    },
}
</script>
<style>
    img.fill-white {
        width: 50px;
        margin: 0px auto;
        padding-bottom: 20px;
    }

    .vsm--menu {
        max-width: 240px !important;
    }

    .v-sidebar-menu.vsm_expanded {
        max-width: 240px !important;
    }

    .logo_link {
        background: #f1f5f9;
        border-right: 1px solid #cbcbcb;
    }

    .logo_link img {
        height: 48px;
    }

    .v-sidebar-menu.vsm_expanded {
        z-index: 10;
    }
</style>
